<template>
  <div>
    <div class="h-content">
      <!-- 搜素条件 -->
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="经销商">
              <el-input v-model="q.agentName" placeholder="请输入经销商名称/编码" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="用户名称">
              <el-input v-model="q.customerName" placeholder="请输入用户名称/用户名称编码" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="渠道" prop="chanel">
              <el-select v-model="q.scenesName" clearable placeholder="请选择" style="width:100%" @change="selectChangedScenesCode">
                <el-option v-for="item in qudaoList"
                           :key="item.code"
                           :label="item.name"
                           :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="q.status" :clearable="true">
                    <el-option label="正常" value="1"></el-option>
                    <el-option label="审核中" value="2"></el-option>
                    <el-option label="作废" value="3"></el-option>
                    <el-option label="已删除" value="0"></el-option>
                    <el-option label="合同退出" value="6"></el-option>
                </el-select>
            </el-form-item>
          </div>
          <el-collapse-transition>
          <div v-show="isScreen">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="年度" prop="year">
                <el-select filterable v-model="q.year" :clearable="true">
                  <el-option
                      v-for="(item) in qyearList"
                      :key="item"
                      :label="item"
                      :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
                <!-- <el-form-item label="经销商类型">
                  <brselectlazy category="DealerCategory_type" :v="q.agentLevel"
                                v-model="q.agentLevel" :clearable="true"/>
                </el-form-item> -->
                <el-form-item label="经销商类型">
                <el-select v-model="q.agentLevel" :clearable="true">
                  <el-option label="一级经销商" value="1"></el-option>
                  <el-option label="专营商" value="3"></el-option>
                  <el-option label="地市直营商" value="6"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="省份" prop="province">
                <el-select v-model="q.province" filterable clearable @change="handleItemChange1($event)"
                           placeholder="省" style="width: 100px;">
                  <el-option
                      v-for="item in shenglist"
                      :key="item.value"
                      :label="item.name"
                      :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="地市" prop="city">
                <el-select v-model="q.city" filterable clearable  @change="handleItemChange3($event)"
                           placeholder="地市" style="width: 100px;">
                  <el-option
                      v-for="item in cityList"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="h-thirdColumn w-newColumn">
  <!--            <el-form-item label="分销商3.0">-->
  <!--              <el-input v-model="q.distributorUsers" placeholder="请输入经销商名称/编码" :clearable="true"></el-input>-->
  <!--            </el-form-item>-->
              <el-form-item label="修改时间" style="width: 50%;">
                <el-date-picker
                    placeholder="请选择"
                    v-model="q.ldateBegin"
                    clearable
                    type="date"
                    value-format="yyyy-MM-dd" >
                </el-date-picker>
                <span class="w-time-to">至</span>
                <el-date-picker
                    placeholder="请选择"
                    v-model="q.ldateEnd"
                    clearable
                    type="date"
                    value-format="yyyy-MM-dd" >
                </el-date-picker>
              </el-form-item>
  <!--            <el-form-item label="对阵模式">-->
  <!--              <brselectlazy category="against_mode" :v="q.againstMode"-->
  <!--                            v-model="q.againstMode" :clearable="true"/>-->
  <!--            </el-form-item>-->

              <el-table-column prop="scenesSubcategory" label="二级分类" width="90px"></el-table-column>
              <el-form-item label="二级分类" prop="scenesSubcategoryCode">
                <el-select v-model="q.scenesSubcategoryCode" clearable placeholder="请选择" style="width:100%">
                  <el-option v-for="item in selectSubcategoryListNow"
                             :key="item.code"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="科室/院系">
                <el-input v-model="q.department" placeholder="请输入科室/院系" :clearable="true"></el-input>
              </el-form-item>
            </div>
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="合同编码">
                <el-input v-model="q.contractId" placeholder="请输入合同编码" :clearable="true"></el-input>
              </el-form-item>

              <el-form-item label="是否需要删除">
                <el-select v-model="q.isDel" :clearable="true">
                  <el-option label="需要删除" value="1"></el-option>
                  <el-option label="无需删除" value="0"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          </el-collapse-transition>
        </el-form>
        <!-- 展开搜素 -->
        <div class="l-screenBox">
          <div class="l-screen" @click="collapseChange">
              <img :src="isScreen?closeScreen:drawScreen" alt="">
              <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
          </div>
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="selectPageAll">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="create">
              新增
            </el-button>
            <!-- <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="create">
                新建目标
            </el-button> -->
          </div>
        </div>
      </div>
      <!-- 结果展示 -->
      <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
        <el-table
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            :data="tableData"
            :border="true"
            stripe
            max-height="560"
            style="width: 100%">
          <el-table-column
              type="selection"
              width="55">
          </el-table-column>
          <el-table-column
              label="序号"
              type="index"
              fixed
              width="50">
          </el-table-column>
          <el-table-column prop="year" label="年份" width="60px"></el-table-column>
          <el-table-column prop="province" label="省份" width="90px"></el-table-column>
          <el-table-column prop="city" label="地市" width="90px"></el-table-column>
          <el-table-column prop="scenesName" label="渠道" width="90px"></el-table-column>
          <el-table-column prop="scenesSubcategory" label="二级分类" width="90px"></el-table-column>
          <el-table-column prop="agentName" label="经销商" width="150px" :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column prop="contractId" label="经销商合同" width="120px"></el-table-column> -->
          <el-table-column prop="customerName" label="用户名称" width="180px">
            <template slot-scope="scope">
              <div  v-if="scope.row.cloor == true" style="color: #F56C6C;">
                {{scope.row.customerName}}
              </div>
              <div  v-if="scope.row.cloor == false">
               {{scope.row.customerName}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="incomeTarget" label="预计目标收入(万元)" width="100px"></el-table-column>
<!--          <el-table-column prop="distributorUsers" label="分销商3.0" width="150px" :show-overflow-tooltip="true"></el-table-column>-->
           <el-table-column prop="facingyewuyuan" label="对阵业务员" width="100px"></el-table-column>
          <el-table-column prop="isTop" label="是否TOP"  width="100px">
          <template slot-scope="scope">
          <span v-if="scope.row.isTop == 0">否</span> <span v-if="scope.row.isTop == 1">是</span>
          </template>
          </el-table-column>
          <el-table-column prop="memo" label="子场景" width="110px" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="department" label="科室/院系" width="110px" :show-overflow-tooltip="true"></el-table-column>

          <el-table-column prop="status" label="状态" width="120px">
            <template slot-scope="scope">
              <div v-if="scope.row.delflag == 1">
                <span v-if="scope.row.status == 1 && scope.row.delflag == 1">正常</span>
                <span v-if="scope.row.status == 2 && scope.row.delflag == 1">审核中</span>
                <span v-if="scope.row.status == 3 && scope.row.delflag == 1">作废</span>
                <span v-if="scope.row.status == 0 && scope.row.delflag == 1">已删除</span>
                <span v-if="scope.row.status == 6 && scope.row.delflag == 1">合同退出</span>
              </div>
              <div v-if="scope.row.delflag == 0">
                <span v-if="scope.row.delflag == 0">已删除</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="isDel" label="是否需要删除" width="110px">
            <template slot-scope="scope">
              <span v-if="scope.row.isDel == 1">需要删除</span>
              <span v-if="scope.row.isDel == 0">无需删除</span>
            </template>
          </el-table-column>
          <el-table-column prop="agentLevel" label="经销商类型" width="110px">
            <template slot-scope="scope">
              <span v-if="scope.row.agentLevel == 1">一级经销商</span>
              <!-- <span v-if="scope.row.agentLevel == 2">分销商</span> -->
              <span v-if="scope.row.agentLevel == 3">专营商</span>
              <!-- <span v-if="scope.row.agentLevel == 4">直单用户</span>
              <span v-if="scope.row.agentLevel == 5">分销商3.0</span> -->
              <span v-if="scope.row.agentLevel == 6">地市直营商</span>
            </template>
          </el-table-column>
<!--          <el-table-column prop="againstMode" label="对阵模式" width="150px">-->
<!--              <template slot-scope="scope">-->
<!--              {{scope.row.againstMode|dictname('against_mode')}}-->
<!--              </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column prop="facingReseller" label="对阵分销商1.0" width="100px" :show-overflow-tooltip="true"></el-table-column>-->
          <el-table-column prop="contractId" label="合同编码" width="140px" :show-overflow-tooltip="true"></el-table-column>
<!--          <el-table-column prop="industryName" label="签约产业" width="130px" :show-overflow-tooltip="true"></el-table-column>-->
          <el-table-column label="超低温&低温&冻干机" width="90px">
            <template slot-scope="scope">
              {{ scope.row.industryCode && scope.row.industryCode.includes('C1') ? '已签约' : '未签约' }}
            </template>
          </el-table-column>
          <el-table-column label="疫苗网" width="90px">
            <template slot-scope="scope">
              {{ scope.row.industryCode && scope.row.industryCode.includes('C2') ? '已签约' : '未签约' }}
            </template>
          </el-table-column>
          <el-table-column label="数智医疗" width="90px">
            <template slot-scope="scope">
              {{ scope.row.industryCode && scope.row.industryCode.includes('C3') ? '已签约' : '未签约' }}
            </template>
          </el-table-column>
          <el-table-column label="数智科研" width="90px">
            <template slot-scope="scope">
              {{ scope.row.industryCode && scope.row.industryCode.includes('C4') ? '已签约' : '未签约' }}
            </template>
          </el-table-column>
          <el-table-column prop="cuname" label="创建人" width="100px" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="cdate" label="创建时间" width="140px" ></el-table-column>
          <el-table-column prop="ldate" label="修改时间" width="140px" ></el-table-column>
          <el-table-column prop="wlProvince" label="万链省份" width="140px" ></el-table-column>
          <el-table-column prop="wlCity" label="万链地市" width="140px" ></el-table-column>

            <el-table-column label="附件" width="100" v-if="this.q.status == 0">
                <template slot-scope="scope">
                  <brupload
                          style="margin-top: 0.1rem;"
                          :showtime="false"
                          :refid="scope.row.refid"
                          reftype="目标对阵-删除附件"
                          :tpFlag = 'true'
                  />
                </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="150"
            >
              <template slot-scope="scope">
              <el-button
                  size="small" class="h-tableLink h-btn"
                  @click="handleEdit(scope.row)">修改
              </el-button>
              <el-button size="small" class="h-tableLink h-btn" type="text"
                         v-if="scope.row.instid != null"
                         @click="showshenpi(scope.row.instid)"
                         v-show="scope.row.instid">跟踪
              </el-button>
              </template>
            </el-table-column>


        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <div class="h-tableBL">
              <el-button :disabled="this.multipleSelection.length === 0" class="h-btn h-formBtn h-bgblueQ"
                         icon="h-el-icon h-el-icon-delete" @click="deleteAgainstUser">批量删除
              </el-button>
              <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcelAll">批量导出
              </el-button>
              <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">导出打印
              </el-button>
              <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                         @click="uploaddownexcelflagbtn">批量导入
              </el-button>
              <uploaddownexcel
                  :visible.sync="uploaddownexcelflag"
                  v-if="uploaddownexcelflag"
                  clsname="bscTargetAgainstUserExcel"
                  :startrow="2" @callback="uploadExcelFilecallback"/>
            </div>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="selectPageAll"/>
          </div>
        </div>
      </div>

      <!-- 新增弹出层 -->
      <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="newDialog" class="h-dialog2" >
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{ titleDig }}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;">
            <el-form :model="add" ref="add" label-position="right" :inline="true"
                     label-width="80" :rules="editFormRules"
                     class="demo-ruleForm h-formbLine h-formbLine1" >
              <el-form-item label="年度" prop="year">
                <el-select filterable v-model="add.year" :clearable="true"  :disabled = "disEdit">
                  <el-option
                      v-for="(item) in qyearList"
                      :key="item"
                      :label="item"
                      :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="省" prop="province">
                <el-select v-model="add.province" filterable clearable @change="handleItemChange1($event)"  :disabled = "disEdit"
                           placeholder="省" style="width: 80%;">
                  <el-option
                      v-for="item in shenglist"
                      :key="item.value"
                      :label="item.name"
                      :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="地市" prop="city">
                <el-select v-model="add.city" filterable clearable @change="handleItemChange2($event)"  :disabled = "disEdit"
                           placeholder="市" style="width: 100%;">
                  <el-option
                      v-for="item in cityList"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
<!--              <el-form-item label="渠道" prop="scenesCode">-->
<!--                <brselect category="sales_region" v-model="add.scenesCode" :v="add.scenesCode" :clearable="true"  :disabled = "disEdit"-->
<!--                           ></brselect>-->
<!--              </el-form-item>-->
              <el-form-item label="渠道" prop="scenesCode">
                <el-select v-model="add.scenesCode" clearable placeholder="请选择" style="width:100%" @change = "battlequdao" :disabled = "disEdit">
                  <el-option v-for="item in qudaoLists"
                             :key="item.code"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="二级分类" prop="scenesSubcategoryCode">
                <el-select v-model="add.scenesSubcategoryCode" clearable placeholder="请选择" style="width:100%" @change="changeScenesSubcategory" :disabled = "disEdit">
                  <el-option v-for="item in subcategoryListNow"
                             :key="item.code"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="经销商" prop="agentName">
                <el-select v-model="add.agentName" remote filterable clearable
                           placeholder="请输入"  :disabled = "disEdit"
                           :remote-method="showComList" @change="showComList1"  >
                  <el-option v-for="(item) in agentList"
                             :key="item.customerName1"
                             :label="item.customerName1"
                             :value="item.customerName1">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item  label="经销商合同"  prop="contractId">
                <el-input v-model="add.contractId" :v="add.contractId" placeholder="请输入">
                </el-input>
              </el-form-item>
              <el-form-item label="用户名称" prop="customerName">
                <el-select v-model="add.customerName" remote filterable :filter-method="showGroupList" :clearable="true"
                           style="width: 135px;"  :disabled = "disEdit"
                           placeholder="请输入"
                           :remote-method="showGroupList" @change="changeShowGroupList"  >
                  <el-option v-for="(item,index) in customerNameList"
                             :key="index"
                             :label="item.deptName"
                             :value="item.deptName">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item  label="预计目标收入(万元)" prop='incomeTarget'>
                <el-input v-model="add.incomeTarget" oninput="value=value.replace(/[^\d.]/g,'')" placeholder="请输入">
                </el-input>
              </el-form-item>
              <el-form-item label="对阵模式" prop='againstMode'>
                <brselect category="against_mode" v-model="add.againstMode" @change="changeAgainstMode($event)"
                          :v="add.againstMode" :clearable="true"/>
              </el-form-item>
              <el-form-item  label="对阵业务员"  prop="facingyewuyuan" v-if="userFlag">
                <el-input v-model="add.facingyewuyuan" :disabled="!userFlag" placeholder="请输入">
                </el-input>
              </el-form-item>
              <el-form-item label="分销商3.0" prop="distributorUsers">
                <el-select v-model="add.distributorUsers"
                           :title="add.distributorUsers"
                           remote filterable :filter-method="showAgentList" clearable  placeholder="请输入"
                           :remote-method="showAgentList" @change="changeAgent($event)" >
                  <el-option v-for="(item) in oneAgentList"
                             :key="item.usercode"
                             :label="item.customerName"
                             :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="经销商类型" prop="agentLevel">
              <el-select v-model="add.agentLevel" :clearable="true">
                <el-option label="一级经销商" value="1"></el-option>
                <el-option label="专营商" value="3"></el-option>
                <el-option label="地市直营商" value="6"></el-option>
              </el-select>
            </el-form-item>
              <el-form-item  :label="facingResellerName" v-if="agentFlag">
                <el-select v-model="add.facingReseller"
                           :title="add.facingReseller"
                           :disabled="!agentFlag"
                           remote filterable :filter-method="showAgentFxList" clearable  placeholder="请输入"
                           :remote-method="showAgentFxList" @change="changeAgentFx($event)" >
                  <el-option v-for="(item) in oneAgentFxList"
                             :key="item.usercode"
                             :label="item.customerName1"
                             :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
<!--              <el-form-item label="子场景" prop='memo' style="margin-left: -15px; margin-right: -15px">-->
<!--                <brselect category="xsyb_lianqun" v-model="add.memo" :v="add.memo" :clearable="true"-->
<!--                          @change="changeLianqun($event)"/>-->
<!--              </el-form-item>-->
              <el-form-item label="子场景" prop='memo'>
                <el-select
                    v-model="add.memo"
                    placeholder="--请选择--"
                    clearable
                    filterable>
                  <el-option
                      v-for="item in subscenesList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="科室/院系" prop='department'>
<!--                <el-select-->
<!--                        v-model="add.department"-->
<!--                        placeholder="&#45;&#45;请选择&#45;&#45;"-->
<!--                        clearable-->
<!--                        filterable>-->
<!--                  <el-option-->
<!--                          v-for="item in subscenesList2"-->
<!--                          :key="item.id"-->
<!--                          :label="item.name"-->
<!--                          :value="item.name">-->
<!--                  </el-option>-->
<!--                </el-select>-->
                <el-input v-model="add.department" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item label="签约产业" prop='industryCodes'>
                <el-select
                        v-model="add.industryCodes"
                        placeholder="--请选择--"
                        multiple
                        filterable
                        allow-create
                        default-first-option>
                  <el-option
                          v-for="item in industryList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item  label="变更原因" v-if="disEditFile" prop='reason'>
                <el-input v-model="add.reason"  placeholder="请输入">
                </el-input>
              </el-form-item>
              <el-form-item label="变更附件" v-if="disEditFile" >
                <brupload :refid="refid"
                          uploadflag
                          delflag
                          :showtime="false"
                          reftype="目标对阵-删除附件"></brupload>
              </el-form-item>

            </el-form>
          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="closeDialog">取消</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()" v-if ="!disEdit">提交</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitUpdate()" v-if ="disEdit">提交修改</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog :close-on-click-modal="false" :visible.sync="centerDialogVisible" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>提交删除附件</h1>
            </div>
          </div>
        </div>
        <div class="h-formLine h-mrb-38" style="margin: 0.38rem 0 0 0;">
          <el-form :inline="true"  class="demo-form-inline h-formBorder"
                   style="margin-top: 0.4rem">
            <el-form-item label="原因" class="h-elformWrap-2" style="margin-left:0.5rem;">
              <el-input type="textarea" v-model="delData.reason" :clearable="true" style="margin-left:0.1rem;"></el-input>
            </el-form-item>
            <br>
            <el-form-item label="上传附件" class="h-elformWrap-2" style="margin-left:0.5rem;">
              <brupload
                  :refid="refid"
                  :uploadflag="true"
                  reftype="目标对阵-删除附件"
                  :showtime="false"
                  :tpFlag = 'true'
              >
              </brupload>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="delAll">确 定</el-button>
        </div>
      </el-dialog>
      <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="delDataVisible" class="h-dialog2">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>目标对阵用户删除</h1>
          </div>
        </div>
      </div>
      <div class="h-formLine h-mrb-38" style="margin: 0.38rem 0 0 0;">
        <el-form :inline="true" :model="delData" class="demo-form-inline h-formBorder"
                 style="margin-top: 0.4rem">
          <el-form-item label="变更原因" class="h-elformWrap-2" style="margin-left:0.5rem;">
            <el-input type="textarea" v-model="delData.reason" :clearable="true" style="margin-left:0.1rem;"></el-input>
          </el-form-item>
          <br>
          <el-form-item label="变更附件" class="h-elformWrap-2" style="margin-left:0.5rem;">

              <brupload
                  :refid="refid"
                  reftype="目标对阵-删除附件"
                  uploadflag
                  delflag
                  :showtime="false"
              >
              </brupload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="delDataVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteAgainstUser">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexceltarget'

export default {
  data() {
    return {
      facingResellerName:"对阵分销商1.0",
      q: {
        // 默认值设为国内,筛选国内相关渠道信息
        userTabType: '国内',
        customerName: '',
        agentName: '',
        scenesName: '',
        scenesSubcategoryCode: '',
        department: '',
        areaName: '',
        pageNo: 1,
        pageSize: 10,
        total: 0,
        // 默认值设为2026
        year: '2026',
        agentLevel:'',
        province:'',
        status:'',
        city:'',
        isDel:null,
      },
      delData: {
        reason: null,
      },
      instid:null,
      showhistory:null,
      centerDialogVisible:false,
      delDataVisible:false,
      qyearList: [],
      quyuList: [],
      qudaoList: [],
      size: '',
      tableData: [],
      //表格
      multipleSelection: [],
      // 展开折叠筛选
      isScreen: false,
      closeScreen:require("@/assets/images/pimg/closeallic.png"),
      drawScreen:require("@/assets/images/pimg/dobleArr.png"),
      uploaddownexcelflag: false,
      agentFlag:false,
      userFlag:false,
      newDialog: false,
      editDialog: false,
      yearList: [new Date().getFullYear(), new Date().getFullYear() + 1],
      weekList: [],
      subscenesList: [],
      subscenesList2: [],
      industryList: [],
      add: {
        year: '',
        id:'',
        areaCode:'',
        province:'',
        city:'',
        scenesCode:'',
        scenesSubcategoryCode: '',// 渠道二级分类
        scenesSubcategory: '',
        customerName:'',
        customerCode:'',
        bscAddressDataId:'',
        agentName:'', //经销商名称
        agentCode:'', //经销商名编码
        contractId:'', //经销商合同
        incomeTarget:'', //预计目标收入
        memo:'', //子场景
        distributorUsers:'', //分销商3.0
        distributorUsersCode:'', //分销商3.0
        falg:'', //标记
        provinceList: [],
        facingyewuyuan:null,//对阵业务员
        agentLevel:null,//经销商类型
        facingReseller:null,//对阵分销
        againstMode:null,
        reason:null,
        refid:null,
        department:null,
        industryCode:null,
        industryCodes:[],
        againstType:1,
        // products: [{
        //   lianqun: '',
        //   price: '',
        //   proModel: '', //产品型号
        //   nosignProcode:'', //非标产品型号
        //   proCode: '',
        //   num: null,
        // }],
      },
      edit: {
        id: '',
        deId: '',
        userList: [0],
        targetContent: '',
        customerName: '',
        visitDateNew: '',
        clearType: ''
      },
      qudaoLists: [],
      subcategoryList: [],
      selectSubcategoryList: [],
      subcategoryListNow: [],
      selectSubcategoryListNow: [],
      authTypeListEdit: [],
      disEdit: false,
      disEditFile: false,
      workList: [],
      AuthoCheck: '',
      authTypeList: [],
      userList: [0],
      weekPlanList: [],
      groupList: [],
      groupArr: [],
      oneAgentList: [],
      oneAgentFxList: [],
      showDel:false,
      titleDig: "",
      iscontract : '',//是否维护了合同
      refid:this.$util.getUuid(),
      fileId:null,
      shenglist: [],// 省份list
      cityList: [],      //城市list
      //用户渠道
      deptSourceChannel2:null,
      customerNameList: [], //用户单位list
      agentList: [],      //签约经销商
      targetId:[],
      editFormRules: {
        year:[{required: true, message: '请输入必填项', trigger: 'blur'}],
        areaCode:[{required: true, message: '请输入必填项', trigger: 'blur'}],
        province:[{required: true, message: '请输入必填项', trigger: 'blur'}],
        city:[{required: true, message: '请输入必填项', trigger: 'blur'}],
        scenesCode:[{required: true, message: '请输入必填项', trigger: 'blur'}],
        agentName:[{required: true, message: '请输入必填项', trigger: 'blur'}],
        contractId:[{required: true, message: '请输入必填项', trigger: 'blur'}],
        customerName:[{required: true, message: '请输入必填项', trigger: 'blur'}],
        incomeTarget:[{required: true, message: '请输入必填项',trigger: 'change'}],
        //facingyewuyuan:[{required: true, message: '请输入必填项',trigger: 'change'}],
        facingReseller: [{required: true, message: '请输入必填项',trigger: 'change'}],
        agentLevel:[{required: true, message: '请输入必填项',trigger: 'change'}],
        againstMode:[{required: true, message: '请输入必填项',trigger: 'change'}]
      },
    }

  },

  methods: {

    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    delAll(){
      // var data = this.multipleSelection.map(item => item.id).join()
      var idlist = [];
      this.multipleSelection.forEach(element => {
        let querys = {};
        querys.id= element.id;
        querys.status = element.status;
        querys.reason = this.delData.reason;
        querys.agentCode = element.agentCode;
        querys.refid = this.refid;
        idlist.push(querys);
      });
      console.log(idlist)
      this.deleteSingle(idlist)
    },
    deleteSelete(query) {
      this.delDataVisible = true;
      this.refid = this.$util.getUuid();
      this.delData.reason = null;
    },
    deleteAgainstUser(value){
      if(this.$store.getters.hasRole('swyl_quyujl')){
        this.centerDialogVisible = true;
        this.refid = this.$util.getUuid();
      }else {
        var idlist = [];
        this.multipleSelection.forEach(element => {
          let querys = {};
          querys.id= element.id;
          querys.status = element.status;
          querys.agentCode = element.agentCode;
        /*  querys.refid = this.refid;
          querys.reason = value.reason;*/
          idlist.push(querys);
        });
        console.log(idlist)
        this.deleteSingle(idlist)
      }
    },
    showshenpi(v){
      this.instid = v;
      this.showhistory = true;
    },
    deleteSingle(id) {
      console.log("id", id)
      var data = id
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ss.grabOrderApi.deleteTargetAgainstUser(data).then(res => {
          console.log(res)
          if (res.f == true) {
            if(this.$store.getters.hasRole('swyl_quyujl')){
              this.$message({
                type: 'success',
                message: '提交成功!'
              });
            }else {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
            this.centerDialogVisible =false;
            this.selectPageAll()
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    changeLianqun(value) {
      if (value != undefined){
        // this.lianqun = value.code;
        this.add.memo = value.name;
      }
      // this.add.lianqun = value.name;
      console.log(value,"value");
      console.log( this.add.lianqun," this.add.lianqun");
    },

    // changequdao(){
    //   ss.Dictservice.listbycategory("sales_region").then(response => {
    //     console.log(response, "sales_chanle")
    //     this.qudaoLists = response;
    //   })
    // },

    selectPageAll() {

      for(var i=0; i< this.shenglist.length; i++){
        if(this.shenglist[i].code == this.q.province){
          this.q.province = this.shenglist[i].name;
          break;
        }
      }

      this.getChongFuCustomerName();
      console.log("this.targetId", this.targetId)
      ss.grabOrderApi.selectPageTargetAgainstUser(this.q).then(res => {
        console.log(res)
        console.log("total", res.total)
        this.tableData = res.records
        this.q.total = res.total
        //获取重复id
        for(var i=0;i<this.tableData.length;i++){
          if(this.targetId.includes(this.tableData[i].id)){
            this.tableData[i].cloor = true
          }else {
            this.tableData[i].cloor = false
          }
          // 转化签约产业
            let industryCodes = this.tableData[i].industryCode;
          if(industryCodes != null && industryCodes !== ""){
            let industryCodeArray = industryCodes.split(",");
            let industryNameStr = '';
            for(var j=0;j<industryCodeArray.length;j++){
              for(var k=0;k<this.industryList.length;k++){
                if(industryCodeArray[j] === this.industryList[k].code){
                    industryNameStr = industryNameStr + this.industryList[k].name + ',';
                }
              }
            }
              // 截取除了最后一个逗号的部分
              this.tableData[i].industryName = industryNameStr.substring(0, industryNameStr.length - 1);
          }
        }
        console.log("table", this.tableData)
      })
    },
    //
    uploaddownexcelflagbtn() {
      this.uploaddownexcelflag = true;
    },
    uploadExcelFilecallback(rd) {
      this.$msg.msgs(rd.msg);
      this.selectPageAll()
    },
    changeTop(val){
      console.log("changeTop",val);
    },
    //导出
    exportExcel() {
      updownfile.down("/api/swyl/v1/bscTargetAgainstUser/downloadExcelNew", this.q, "post", 'data');
    },
    //导出
    exportExcelAll() {
      updownfile.down("/api/swyl/v1/bscTargetAgainstUser/downloadExcel", this.q, "post", 'data');
    },
    getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
    },
    handleEdit(value){
      this.newDialog = true;
      this.titleDig = "修改目标对阵用户"
      this.disEdit = true;
      if(this.$store.getters.hasRole('swyl_quyujl')){
        this.disEditFile = true;
      }
      this.refid = this.$util.getUuid();
      this.add = value;
      this.add.agentLevel = value.agentLevel+"";
      // 将签约产业字符串转为数组
      if(value.industryCode){
          this.add.industryCodes = value.industryCode.split(',');
      }else{
          this.add.industryCodes = [];
      }
    },
    //新增日清
    create() {
      this.newDialog = true;
      this.titleDig = "新增目标对阵用户"
      this.add = {};
      this.disEdit = false;
    },
    loadArea(i) {
      let proSelect = {
        pcode: 0,
        level: 1,
      }
      console.log(proSelect)
      ss.Dictservice.arealist(proSelect).then(rd => {
        this.shenglist = rd;
      })
    },
    zichuangjing(){
        var data = this.$store.getters.dictlist("xsyb_lianqun");
        var data2 = this.$store.getters.dictlist("bsc_subscenes");
        this.subscenesList = data;
        this.subscenesList2 = data2;
        console.log(this.subscenesList,"this.subscenesList");
    },

    // 省份选择器
    handleItemChange1(o, salesman, city) {
      if(o == ""){
        return
      }
      console.log("city1111111111111",city);
      this.city = city;
      if (city == null) {
        this.city = null;
      }
      this.add.provinceList = _.find(this.shenglist, {code: o});
      ss.Dictservice.getCity({code: o}).then(rd => {
        this.cityList = rd.zlist;
      })
    },
    handleItemChange3(o) {
      this.q.city = o;
    },
    handleItemChange2(o) {
      this.add.city = o;
    },
    changeShowGroupList(value){
      // if(value == "" ){
      //   this.deptSourceChannel2 = '';
      //   return;
      // }
      // ss.MuBiao.getUserLoud(value).then(res => {
      //   console.log(res);
      //   this.customerNameList = res
      //   if (undefined == res[0].deptSourceChannel2 || null == res[0].deptSourceChannel2 || '' == res[0].deptSourceChannel2){}
      //   if (null != this.add.scenesCode && '' != this.add.scenesCode){
      //     if (undefined == res[0].deptSourceChannel2 || null == res[0].deptSourceChannel2 || '' == res[0].deptSourceChannel2){
      //       this.add.customerName = '';
      //       this.$message({
      //         showClose: true,
      //         type: "warning",
      //         message: '用户单位未维护渠道，请先维护用户单位渠道信息！',
      //         center: true
      //       });
      //       this.add.customerName = '';
      //       return;
      //     }
      //     if (this.add.scenesCode != res[0].deptSourceChannel2){
      //       this.add.customerName = '';
      //       this.$message({
      //         showClose: true,
      //         type: "warning",
      //         message: '用户单位渠道与选择的渠道不一致，请先检查用户单位渠道！',
      //         center: true
      //       });
      //       return;
      //     }
      //   }
      //   this.deptSourceChannel2 = res[0].deptSourceChannel2
      //   this.add.customerCode = res[0].deptId
      //   this.add.bscAddressDataId = res[0].id
      // })
    },
    //获取用户单位
    showGroupList(value) {
      if(value == "" ){
        return;
      }
      ss.MuBiao.getUserLoud(value).then(res => {
        console.log(res);
        this.customerNameList = res
        this.add.customerCode = res[0].deptId
        this.add.bscAddressDataId = res[0].id
      })
    },
    //签约经销商
    showComList(value) {
      if(value == "" ){
        return;
      }
      ss.netApi.selectByUserNameLoud(value).then(res => {
        console.log(res)
        this.agentList = res.obj
        if(this.agentList.length === 1){
          this.add.agentCode = res.obj[0].usercode;
        }

      })
    },
    //渠道
    battlequdao() {

      console.log(this.add.scenesCode, "this.add.scenesCode");
      console.log(this.add.scenesName, "this.add.scenesName");
      if (null != this.deptSourceChannel2 && '' != this.deptSourceChannel2){
        if (this.add.scenesCode != this.deptSourceChannel2){
          this.add.scenesCode = null;
          this.$message({
            showClose: true,
            type: "warning",
            message: '用户单位渠道与选择的渠道不一致，请先检查用户单位渠道！',
            center: true
          });
        }
      }
      // 渠道二级分类
        if (null !== this.add.scenesCode && this.add.scenesCode !== '') {
            this.subcategoryListNow = this.subcategoryList.filter(item => {
                return item.refid === this.add.scenesCode
            });
        }
    },
    selectChangedScenesCode() {
      console.log("scenesName",this.q.scenesName);
      console.log("selectSubcategoryListNow",this.selectSubcategoryListNow);
      // 渠道二级分类
      if (null !== this.q.scenesName && this.q.scenesName !== '') {
        this.selectSubcategoryListNow = this.selectSubcategoryList.filter(item => {
          return item.refidName === this.q.scenesName
        });
      }
    },
    // 渠道二级分类
    changeScenesSubcategory() {
        // 赋值渠道二级分类,根据二级分类code获取name
        let subcategoryListCheck = this.subcategoryListNow.filter(item => {
            return item.code === this.add.scenesSubcategoryCode
        })
        // 添加空值检查
        if (subcategoryListCheck.length > 0) {
            this.add.scenesSubcategory = subcategoryListCheck[0].name
        } else {
            this.add.scenesSubcategory = ''
        }
    },
      // 获取签约产业
    getIndustryList() {
        var allList = this.$store.getters.dictlist("swyl_industry_ct");
        // 筛掉code = C6的样本网
        this.industryList = allList.filter(item => {
            return item.code !== 'C6'
        })
    },
    getChongFuCustomerName(){
      ss.grabOrderApi.getChongFuCustomerName().then(res => {
        this.targetId = res.msg
      })
    },
    showComList1(value) {
      if (this.add.agentName != ''){
        let aglist = this.agentList;
        let ageentName = this.add.agentName;
        var find1 = aglist.find(a => a.customerName1 == ageentName);
        let cdate = find1.cdate;
        var date1 = new Date(cdate);
        var date2 = new Date("2023-01-01");
        var result = date1 > date2;
        if (find1.contractId == undefined  || find1.contractId == ''){
        }else {
          this.add.contractId = find1.contractId;
        }
        //23年以后注册的经销商才校验是否有合同编号（必填）
        this.iscontract =  result
        this.add.agentCode = find1.usercode;
        if (result == true ){
          if (this.add.contractId == '' || this.add.contractId == null || this.add.contractId == 'undefined') {
            this.$message({
              showClose: true,
              type: "warning",
              message: '该经销商维护经销商合同请先维护经销商合同！',
              center: true
            });
          }
        }
      }else {
        this.add.contractId = ''
      }
    },
    getqWeeksBySelectYear() {
      this.getqWeeks(this.q.year, 1);
    },
    // 展开折叠
    collapseChange() {
      this.isScreen = !this.isScreen;
    },
    showAgentFxList(value) {
      ss.UserService.selectAgentByNameFxOne(value,this.add.againstMode).then(rd=>{
        console.log(rd);
        this.oneAgentFxList = rd.msg;
      })
    },
    rest() {
      var pageSize = this.q.pageSize;
      var pageNo = this.q.pageNo;
      var total = this.q.total;
      this.q = {
        pageSize: pageSize,
        pageNo: pageNo,
        total: total,
        agentName: '',
        customerName: '',
        areaCode: '',
        chanelCode: ''
      }
    },
    commitUpdate(){
      if (!this.add.year){
        this.$message({
          type: "error",
          message: '年份不能为空！'
        });
        return false;
      }
      if (!this.add.province){
        this.$message({
          type: "error",
          message: '省不能为空！'
        });
        return false;
      }
      if (!this.add.city){
        this.$message({
          type: "error",
          message: '地市不能为空！'
        });
        return false;
      }
      if (!this.add.scenesCode){
        this.$message({
          type: "error",
          message: '渠道不能为空！'
        });
        return false;
      }
      if (!this.add.agentName){
        this.$message({
          type: "error",
          message: '经销商不能为空！'
        });
        return false;
      }
      if (this.iscontract == true){
        if (!this.add.contractId){
          this.$message({
            type: "error",
            message: '经销商合同不能为空,请先维护经销商合同！'
          });
          return false;
        }
      }
      if (!this.add.customerName){
        this.$message({
          type: "error",
          message: '用户单位不能为空！'
        });
        return false;
      }
      if (!this.add.incomeTarget){
        this.$message({
          type: "error",
          message: '预计目标收入不能为空！'
        });
        return false;
      }
      if (!this.add.reason && this.$store.getters.hasRole('swyl_quyujl')){
        this.$message({
          type: "error",
          message: '变更原因不能为空！'
        });
        return false;
      }
      //根据对阵模式判断
      //一级经销商独立对阵：选择这种情况，分销商一格不用强制必填，业务员一格强制必填2个字符以上
      //一级经销商+分销商合作对阵：选择这种情况，分销商一格需强制必填5个字符以上的单位名称，业务员一格强制必填2个字符以上
      //分销商独立对阵：选择这种情况，分销商一格需强制必填5个字符以上的单位名称，业务员一格不强制必填

      if(!this.add.againstMode){
        this.$message({
          type: "error",
          message: '对阵模式入不能为空！'
        });
        return false;
      }else {
        if(this.add.againstMode == 1){
          if(!this.add.facingyewuyuan || /^ *$/.test(this.add.facingyewuyuan)){
            this.$message({
              type: "error",
              message: '对阵业务员不能为空或者不能为空格'
            });
            return false;
          }
          if(this.add.facingyewuyuan.length < 2 ){
            this.$message({
              type: "error",
              message: '对阵业务员字符必须在2个或者2个以上！'
            });
            return false;
          }
        }else if(this.add.againstMode == 2){
          if(!this.add.facingyewuyuan || /^ *$/.test(this.add.facingyewuyuan)){
            this.$message({
              type: "error",
              message: '对阵业务员不能为空或者不能为空格'
            });
            return false;
          }
          if(this.add.facingyewuyuan.length < 2 ){
            this.$message({
              type: "error",
              message: '对阵业务员字符必须在2个或者2个以上！'
            });
            return false;
          }
          if((!this.add.facingReseller || /^ *$/.test(this.add.facingReseller)) && (!this.add.distributorUsers || /^ *$/.test(this.add.distributorUsers))){
            console.log("/^ *$/.test(this.add.facingReseller): ",/^ *$/.test(this.add.facingReseller))
            this.$message({
              type: "error",
              message: '对阵分销商1.0或者分销商3.0不能为空或者不能为空格'
            });
            return false;
          }
          if(this.add.facingReseller && this.add.facingReseller.length < 5 ){
            this.$message({
              type: "error",
              message: '对阵分销商1.0字符必须在5个或者5个以上！'
            });
            return false;
          }
        }else if(this.add.againstMode == 3){
          if(!this.add.facingReseller || /^ *$/.test(this.add.facingReseller)){
            console.log("/^ *$/.test(this.add.facingReseller): ",/^ *$/.test(this.add.facingReseller))
            this.$message({
              type: "error",
              message: '对阵分销商1.0不能为空或者不能为空格'
            });
            return false;
          }
          if(this.add.facingReseller.length < 5 ){
            this.$message({
              type: "error",
              message: '对阵分销商1.0字符必须在5个或者5个以上！'
            });
            return false;
          }
        }
      }
      this.add.refid = this.refid;
      ss.grabOrderApi.insertbattle(this.add).then(res=> {
        if (res.f) {
          this.$message({
            type: "success",
            message: '修改成功！'
          });
          this.newDialog = false;
          this.selectPageAll();
        }
      })
    },
    commitCreate(){
      if (!this.add.year){
        this.$message({
          type: "error",
          message: '年份不能为空！'
        });
        return false;
      }
      if (!this.add.province){
        this.$message({
          type: "error",
          message: '省不能为空！'
        });
        return false;
      }
      if (!this.add.city){
        this.$message({
          type: "error",
          message: '地市不能为空！'
        });
        return false;
      }
      if (!this.add.scenesCode){
        this.$message({
          type: "error",
          message: '渠道不能为空！'
        });
        return false;
      }
      if (!this.add.agentName){
        this.$message({
          type: "error",
          message: '经销商不能为空！'
        });
        return false;
      }
      if (this.iscontract == true){
        if (!this.add.contractId){
          this.$message({
            type: "error",
            message: '经销商合同不能为空,请先维护经销商合同！'
          });
          return false;
        }
      }
      if (!this.add.customerName){
        this.$message({
          type: "error",
          message: '用户单位不能为空！'
        });
        return false;
      }
      if (!this.add.incomeTarget){
        this.$message({
          type: "error",
          message: '预计目标收入不能为空！'
        });
        return false;
      }
      //根据对阵模式判断
      //一级经销商独立对阵：选择这种情况，分销商一格不用强制必填，业务员一格强制必填2个字符以上
      //一级经销商+分销商合作对阵：选择这种情况，分销商一格需强制必填5个字符以上的单位名称，业务员一格强制必填2个字符以上
      //分销商独立对阵：选择这种情况，分销商一格需强制必填5个字符以上的单位名称，业务员一格不强制必填

      if(!this.add.againstMode){
        this.$message({
          type: "error",
          message: '对阵模式入不能为空！'
        });
        return false;
      }else {
        if(this.add.againstMode == 1){
          if(!this.add.facingyewuyuan || /^ *$/.test(this.add.facingyewuyuan)){
            this.$message({
              type: "error",
              message: '对阵业务员不能为空或者不能为空格'
            });
            return false;
          }
          if(this.add.facingyewuyuan.length < 2 ){
            this.$message({
              type: "error",
              message: '对阵业务员字符必须在2个或者2个以上！'
            });
            return false;
          }
        }else if(this.add.againstMode == 2){
          if(!this.add.facingyewuyuan || /^ *$/.test(this.add.facingyewuyuan)){
            this.$message({
              type: "error",
              message: '对阵业务员不能为空或者不能为空格'
            });
            return false;
          }
          if(this.add.facingyewuyuan.length < 2 ){
            this.$message({
              type: "error",
              message: '对阵业务员字符必须在2个或者2个以上！'
            });
            return false;
          }
          if(!this.add.facingReseller || /^ *$/.test(this.add.facingReseller)){
            console.log("/^ *$/.test(this.add.facingReseller): ",/^ *$/.test(this.add.facingReseller))
            this.$message({
              type: "error",
              message: '对阵分销商不能为空或者不能为空格'
            });
            return false;
          }
          if(this.add.facingReseller.length < 5 ){
            this.$message({
              type: "error",
              message: '对阵分销商字符必须在5个或者5个以上！'
            });
            return false;
          }
        }else if(this.add.againstMode == 3){
          if(!this.add.facingReseller || /^ *$/.test(this.add.facingReseller)){
            console.log("/^ *$/.test(this.add.facingReseller): ",/^ *$/.test(this.add.facingReseller))
            this.$message({
              type: "error",
              message: '对阵分销商不能为空或者不能为空格'
            });
            return false;
          }
          if(this.add.facingReseller.length < 5 ){
            this.$message({
              type: "error",
              message: '对阵分销商字符必须在5个或者5个以上！'
            });
            return false;
          }
        }
      }
      if (this.add.provinceList != null){
        this.add.province = this.add.provinceList.name;
      }
      // 将签约产业数组转为逗号分隔的字符串
      if(this.add.industryCodes && this.add.industryCodes.length > 0){
          this.add.industryCode = this.add.industryCodes.join(',');
      }else{
          this.add.industryCode = '';
      }
      this.add.againstType = 1;
      ss.grabOrderApi.insertbattle(this.add).then(res=>{
        if (res.msg == 1 && res.f == true){
          this.$confirm(this.add.customerName +'已存在,确定要保存吗？', "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            this.add.customerName = null;
            this.editFormRules = {
              customerName: [{required: true, message: '用户单位重复', trigger: 'change'}],
              year:[{required: true, message: '请输入必填项', trigger: 'blur'}],
              areaCode:[{required: true, message: '请输入必填项', trigger: 'blur'}],
              province:[{required: true, message: '请输入必填项', trigger: 'blur'}],
              city:[{required: true, message: '请输入必填项', trigger: 'blur'}],
              scenesCode:[{required: true, message: '请输入必填项', trigger: 'blur'}],
              agentName:[{required: true, message: '请输入必填项', trigger: 'blur'}],
              incomeTarget:[{required: true, message: '请输入必填项',trigger: 'change'}],
            }
              })
              .catch(() => {
                this.$message.error('用户单位重复,要保存请在子场景里填写说明');
              });
        }
        if (res.msg != 1 && res.f == true){
          this.selectPageAll();
          this.closeDialog();
        }
      })
    },
    exit() {
      this.closeDialog()
    },
    closeDialog(){
      this.newDialog = false,
          this.add.id = '',
          this.add.year = '',
          this.add.areaCode = '',
          this.add.province = '',
          this.add.city = '',
          this.add.channelCode = '',
          this.add.customerName = '',
          this.add.customerCode = '',
          this.add.agentName = '',
          this.add.agentCode = '',
          this.add.contractId = '',
          this.add.incomeTarget = '',
          this.add.memo = '',
          this.add.scenesCode = '',
          this.add.facingyewuyuan =null,//对阵业务员
          this.add.agentLevel = '',
          this.add.facingReseller = null,
          //重新打开弹出窗，刷新校验
          this.$refs.add.resetFields();
    },
    getQuyuList() {
      ss.Dictservice.listbycategory("YLRegion").then(rd => {
        this.quyuList = rd;
      })
    },
    getQudaoList() {
      ss.Dictservice.listbycategory("sales_region").then(rd => {
        this.qudaoList = rd;
        console.log( this.qudaoList," this.qudaoList");
        if(this.qudaoList){
          for (var i=0;i<this.qudaoList.length;i++){
            if( this.qudaoList[i].code<8){
              if(this.qudaoList[i].code != 5 && this.qudaoList[i].code != 6){
                this.qudaoLists.push(this.qudaoList[i]);
              }
            }
          }
          console.log( this.qudaoLists," this.qudaoList23333333");
        }
      })
    },
    getSubcategoryList() {
        ss.Dictservice.listbycategory("bsc_subcategory").then(rd => {
          this.subcategoryList = rd;
          const refidMap = {
            '001': '高科',
            '002': '医疗',
            '004': '制药企业',
            '007': '疾控'
          };
          // 处理数据并添加 refidName 字段
          this.selectSubcategoryList = rd.map(item => {
            return {
              ...item,
              refidName: refidMap[item.refid] || ''
            };
          });
          this.subcategoryListNow = this.subcategoryList;
          this.selectSubcategoryListNow = this.subcategoryList;
          console.log( this.subcategoryList," this.subcategoryList")
        })
    },
    getWeeks(y) {
      ss.MuBiao.getWeekList({year: y}).then(rd => {
        this.weekList = rd;
      })
    },
    getWeeksBySelectYear() {
      this.getWeeks(this.add.year);
      ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
        this.addlianqunList = rd;
      })
    },
    showAgentList(value) {
      ss.UserService.selectAgentByNameFx(value).then(rd=>{
        console.log(rd);
        this.oneAgentList = rd.msg;
      })
    },
    changeAgent(value){
      this.add.distributorUsers = value.customerName
      this.add.distributorUsersCode = value.usercode
    },
    changeAgentFx(value){
      this.add.facingReseller = value.customerName1
    },
    changeAgainstMode(value){
      if(value.code == 1){
        this.userFlag = true;
        this.agentFlag = false;
        this.facingResellerName = '对阵分销商1.0';
      }else if(value.code == 2) {
        this.userFlag = true;
        this.agentFlag = true;
        this.facingResellerName = '对阵分销商1.0 or 2.0';
      }else if(value.code == 3) {
        this.facingResellerName = '对阵分销商1.0';
        this.userFlag = false;
        this.agentFlag = true;
      }
    },
  },
  watch: {
    'add.customerName': {
      deep: true,
      handler: function (newVal, oldVal) {
        this.groupArr = [];//这是定义好的用于存放下拉提醒框中数据的数组
        var len = this.groupList.length;//groupList
        var arr = [];
        for (var i = 0; i < len; i++) {//根据输入框中的值进行模糊匹配
          if (this.groupList[i].name.indexOf(this.add.customerName) >= 0) {
            arr.push({
              value: this.groupList[i].name,
              id: this.groupList[i].id
            })
          }
        }
        this.groupArr = arr
      }
    },
  },
  created() {
    this.selectPageAll()
    this.add.year = this.yearList[0]
    this.q.status = "1"
    this.getWeeks(new Date().getFullYear());
    this.getQuyuList();
    this.getQudaoList();
    this.getSubcategoryList();
    this.getIndustryList();
    for (var i = 2022; i < new Date().getFullYear() + 3; i++) {
      this.qyearList.push(i);
    }
    this.loadArea();

    this.zichuangjing();
     this.changequdao();
  },
  components: {
    uploaddownexcel,
  },
}
</script>
<style scoped>
/deep/ .h-formbLine .el-form-item__label {
  width: 100px;
}


/deep/ .h-formbLine .el-form-item__content {
  width: 150px;
}
</style>
